import React from 'react';
import { Loader2, AlertCircle } from 'lucide-react';

interface LoadingErrorStateProps {
  loading?: boolean;
  error?: string | null;
  loadingMessage?: string;
  errorMessage?: string;
}

const LoadingErrorState: React.FC<LoadingErrorStateProps> = ({
  loading = false,
  error = null,
  loadingMessage = 'Processing...',
  errorMessage = 'Something went wrong!',
}) => {
  if (error) {
    return (
      <div className="bg-white rounded-xl p-6 flex flex-col justify-center min-h-[120px] transition-shadow duration-200 transition-colors border-[1px] border-cardborder mb-8">
        <div className="flex items-center gap-2 justify-center text-red-500">
          <AlertCircle className="w-5 h-5" />
          <span>{error || errorMessage}</span>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="bg-white rounded-xl p-6 flex flex-col justify-center min-h-[120px] transition-shadow duration-200 transition-colors border-[1px] border-cardborder mb-8">
        <div className="flex justify-center items-center gap-2">
          <Loader2 className="w-10 h-10 animate-spin text-brand/80" />
          <span className="text-sm text-gray-500">{loadingMessage}</span>
        </div>
      </div>
    );
  }

  return null;
};

export default LoadingErrorState;

